import type { UseMutationOptions } from '@tanstack/react-query';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { getToken as getClerkToken } from 'clerk-get-token';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function mutationOptions<TData, TError, TVariables, TContext>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>
): UseMutationOptions<TData, TError, TVariables, TContext> {
  return options;
}

export async function getToken() {
  return getClerkToken();
}
